export default __webpack_public_path__ + "static/media/random.fa3cd4ab.svg";